// Mock data for XpertAdvisor clone

export const services = [
  {
    id: 1,
    title: "SOP & LOR Writing",
    description: "Craft compelling narratives that showcase your unique journey and aspirations. Our professional writers work closely with you to create personalized Statements of Purpose and Letters of Recommendation that resonate with admission committees. We ensure your documents highlight your achievements, motivations, and potential while adhering to university-specific requirements and formatting guidelines.",
    icon: "file-text",
    features: ["Personalized Content", "Expert Writers", "Multiple Revisions", "University-specific Format"]
  },
  {
    id: 2,
    title: "Visa Guidance",
    description: "Navigate the complex visa application process with confidence. Our experienced visa consultants provide end-to-end support, from document preparation to interview coaching. We stay updated with the latest visa regulations and requirements for different countries, ensuring your application is complete, accurate, and submitted on time. Our mock interview sessions prepare you to confidently face visa officers and answer questions effectively.",
    icon: "clipboard-check",
    features: ["Document Checklist", "Interview Preparation", "Application Support", "Status Tracking"]
  },
  {
    id: 3,
    title: "Mock Interviews",
    description: "Practice sessions with experienced counselors to prepare you for university admissions and visa interviews.",
    icon: "mic",
    features: ["Realistic Scenarios", "Expert Feedback", "Confidence Building", "Multiple Sessions"]
  },
  {
    id: 4,
    title: "Post-landing Services",
    description: "Comprehensive support after reaching your destination including accommodation, local registration, and orientation.",
    icon: "map-pin",
    features: ["Accommodation Assistance", "Local Registration", "Bank Account Setup", "Orientation Support"]
  },
  {
    id: 5,
    title: "Flight Ticket Booking",
    description: "Convenient flight booking services with competitive rates and flexible options for your international travel.",
    icon: "plane",
    features: ["Best Price Guarantee", "Flexible Dates", "Travel Insurance", "24/7 Support"]
  }
];

export const specializedPrograms = [
  {
    id: 1,
    title: "Nursing in Germany",
    description: "Comprehensive program for nursing professionals looking to build their career in Germany. Get guidance on language requirements, qualification recognition, and employment opportunities.",
    features: ["German Language Training", "Qualification Recognition", "Job Placement Assistance", "Cultural Integration Support"]
  },
  {
    id: 2,
    title: "Workforce Management",
    description: "Advanced training and placement programs for workforce management professionals. Develop leadership skills and explore international career opportunities.",
    features: ["Leadership Development", "International Placement", "Skills Assessment", "Career Advancement"]
  }
];

export const universities = [
  { id: 1, name: "Harvard University", country: "United States", degree: "Masters", ranking: 1 },
  { id: 2, name: "Stanford University", country: "United States", degree: "Masters", ranking: 2 },
  { id: 3, name: "MIT", country: "United States", degree: "PhD", ranking: 3 },
  { id: 4, name: "University of Oxford", country: "United Kingdom", degree: "Masters", ranking: 4 },
  { id: 5, name: "University of Cambridge", country: "United Kingdom", degree: "Bachelors", ranking: 5 },
  { id: 6, name: "ETH Zurich", country: "Switzerland", degree: "Masters", ranking: 6 },
  { id: 7, name: "University of Toronto", country: "Canada", degree: "Bachelors", ranking: 7 },
  { id: 8, name: "University of Melbourne", country: "Australia", degree: "Masters", ranking: 8 }
];

export const countries = [
  "United States", "United Kingdom", "Canada", "Australia", "Germany", 
  "Switzerland", "France", "Netherlands", "Sweden", "Ireland"
];

export const stats = [
  { value: "1500+", label: "Universities", icon: "graduation-cap" },
  { value: "21+", label: "Countries", icon: "globe" },
  { value: "100+", label: "Students Placed", icon: "users" },
  { value: "$100M+", label: "Loan Amount", icon: "dollar-sign" }
];

export const processSteps = [
  {
    step: 1,
    title: "Profile Analysis",
    description: "Complete evaluation of your background and goals"
  },
  {
    step: 2,
    title: "University Selection",
    description: "Shortlist universities matching your profile"
  },
  {
    step: 3,
    title: "Application Support",
    description: "Complete assistance with applications and documentation"
  },
  {
    step: 4,
    title: "Visa & Travel",
    description: "Visa guidance and travel arrangements"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Shruti Reddy",
    university: "Study Abroad Program",
    country: "",
    program: "Student Review",
    testimonial: "Good place to start off your abroad dreams. Helpful staff and management.",
    rating: 5
  },
  {
    id: 2,
    name: "Hiran Pujari",
    university: "Study Abroad Program",
    country: "",
    program: "Student Review",
    testimonial: "The support was excellent throughout my entire process",
    rating: 5
  },
  {
    id: 3,
    name: "HARSHA GUNA",
    university: "Study Abroad Program",
    country: "",
    program: "Student Review",
    testimonial: "Really appreciated their honest and clear guidance on all the options available! Would highly recommend!",
    rating: 5
  }
];

export const footerLinks = {
  services: [
    "SOP & LOR Writing",
    "Visa Guidance"
  ],
  destinations: [
    "United States",
    "United Kingdom",
    "Canada",
    "Australia",
    "Germany",
    "Switzerland",
    "View All Countries"
  ]
};
